import PropTypes from "prop-types";

export default function AuthShell({
  badge,
  title,
  description,
  children,
  asideTitle,
  asideDescription,
  summaryItems = [],
}) {
  return (
    <section className="mx-auto w-full max-w-5xl">
      <div className="grid gap-3 lg:grid-cols-[1.08fr_0.92fr]_">
        <div className="portal-page-card relative overflow-hidden rounded-[1.8rem] p-4 md:p-5">
          <div className="pointer-events-none absolute -left-16 top-0 h-40 w-40 rounded-full bg-[radial-gradient(circle,rgba(255,178,91,0.2),transparent_70%)]" />
          <div className="pointer-events-none absolute bottom-0 right-0 h-36 w-36 rounded-full bg-[radial-gradient(circle,rgba(229,106,0,0.16),transparent_72%)]" />

          <div className="relative">
            <span className="portal-badge inline-flex rounded-full px-3 py-1 text-[11px] font-bold">
              {badge}
            </span>
            <h1
              className="mt-3 text-xl font-black leading-tight md:text-3xl"
              style={{ color: "var(--layout-text)" }}
            >
              {title}
            </h1>
            <p
              className="mt-2 max-w-2xl text-sm leading-6"
              style={{ color: "var(--layout-text-muted)" }}
            >
              {description}
            </p>
          </div>

          <div className="relative mt-4">{children}</div>
        </div>

        {/* <aside className="hidden lg:block portal-page-card relative overflow-hidden rounded-[1.8rem] p-4 md:p-5">
          <div className="portal-accent-bg mb-4 flex items-center justify-between rounded-[1.35rem] px-4 py-3 text-white">
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.3em] text-white/75">
                SHAM
              </p>
              <h2 className="mt-1 text-lg font-black md:text-xl">
                {asideTitle}
              </h2>
            </div>
            <img
              src="/assets/images/clientLogo.png"
              alt="SHAM"
              className="h-12 w-12 object-contain md:h-14 md:w-14"
            />
          </div>

          <p
            className="text-sm leading-6"
            style={{ color: "var(--layout-text-muted)" }}
          >
            {asideDescription}
          </p>

          <div className="mt-4 grid gap-2.5">
            {summaryItems.map((item) => (
              <div
                key={item.title}
                className="portal-panel-soft rounded-[1.15rem] px-3.5 py-3"
              >
                <p className="text-xs font-bold portal-accent">{item.title}</p>
                <p
                  className="mt-1 text-sm font-semibold leading-6"
                  style={{ color: "var(--layout-text)" }}
                >
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </aside> */}
      </div>
    </section>
  );
}

AuthShell.propTypes = {
  badge: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  asideTitle: PropTypes.string.isRequired,
  asideDescription: PropTypes.string.isRequired,
  summaryItems: PropTypes.array,
};
